import Account from './Account';

import { IconSystemAvatar } from 'components/Icons';
import Typography from 'components/Typography';

import { title } from './content';
import { StyledHeroWrapper, StyledLeftContent, StyledRightContent } from './styles';

const Hero = ({ id }: { id: string }) => {
  return (
    <StyledHeroWrapper id={id}>
      <StyledLeftContent>
        <IconSystemAvatar />
      </StyledLeftContent>
      <StyledRightContent>
        <Typography as='span' color='inverse' variant='heading' size='xl'>
          {title}
        </Typography>
      </StyledRightContent>
      <Account />
    </StyledHeroWrapper>
  );
};

export default Hero;
